import React, { useEffect, useState } from 'react';
import { AiFillCustomerService, AiOutlineBell, AiOutlineUser } from 'react-icons/ai';
import { FaBars, FaChartBar, FaUserSecret, FaHandshake, FaUser, FaBell, FaList, FaCog, FaUsers, FaUpload, FaMoneyBill, FaSignOutAlt, FaBuilding, FaShoppingCart, FaCashRegister, FaUserSlash, FaReceipt, FaTimes } from 'react-icons/fa';
import { FaListCheck, FaUsersGear } from 'react-icons/fa6';
import { MdDashboard, MdEvent, MdPayments } from 'react-icons/md';
import { Outlet, useLocation, NavLink  } from 'react-router-dom';
import { useAuth } from '../context/auth-context';
import { toast } from 'react-toastify';
import axios from 'axios';
import { rootUrl } from '../helpers';
import { FcCustomerSupport, FcPlanner } from 'react-icons/fc';
import { BiReceipt } from 'react-icons/bi';
import { PiInvoice } from 'react-icons/pi';
import { CiBank, CiSettings } from 'react-icons/ci';
import { IoIosSwap } from 'react-icons/io';
import { GrProjects, GrUserAdmin } from 'react-icons/gr';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function UserLayout() {

    const auth = useAuth();

    const [routes, setRoutes] = useState([]) 
    const [allData, setAllData] = useState([]) 
    const [transactions, setTransactions] = useState([]);


    const routez = [
      { path: '/', name: 'Dashboard', icon: MdDashboard },
      { path: '/bills', name: 'Bills', icon: PiInvoice },
      { path: '/projects', name: 'Projects', icon: GrProjects },
      { path: '/cashbook', name: 'Transactions', icon: FaCashRegister },
      { path: '/suppliers', name: 'Payments', icon: MdPayments },
      { path: '/customers', name: 'Receipts', icon: FaReceipt },
      { path: '/clients', name: 'Clients', icon: FaUsers },
      { path: '/recon', name: 'Bank Recon', icon: CiBank },
      { path: '/journal', name: 'Journal', icon: IoIosSwap },
      { path: '/budget', name: 'Budget', icon: MdEvent },
      { path: '/audit', name: 'Audit', icon: FaUserSecret },
      { path: '/reports', name: 'Reports', icon: FaChartBar },
    ];


    const check = async () =>{
      try{
        const response = await axios.get(rootUrl(`/getNavRoles/${auth.user?.id}`))
        setRoutes([])
        setRoutes(prev=>[...prev, { path: '/', name: 'Dashboard', icon: MdDashboard }])
        routez.map((res)=>{
          if(response.data.data.find(a=>a.name == res.name)){
            setRoutes(prev=>[...prev, res])
          }
        })
          
      }catch(e){
        // window.location.href = "/"
      }
    }


    const getGen = async () =>{
      try{
        const response = await axios.get(rootUrl(`/getGeneral/${auth.user?.id}`))
        if(response.data.status == 200){
             setAllData(response.data.data)
        }
      }catch(e){
        // toast.error(e?.message)
      }
    }

    const fetchTransactions = async () => {
      try {
        const response = await axios.get(rootUrl(`/getTrans/${auth.user?.id}`));
        setTransactions(response.data.cash);
      } catch (error) {
        console.error("Failed to fetch transactions:", error);
      }
    };
  



    useEffect(()=>{
      check()
      getGen()
      fetchTransactions()
    }, [])

    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const location = useLocation();
    const currentUrl = location.pathname + location.search;
  
    const toggleSidebar = () => {
      setIsSidebarOpen(!isSidebarOpen);
    };
  
    const signOut = () => {
      auth.logOut(()=>{
         window.location.href = "/"
      })
  
    }

    return (
      <div className="flex h-screen bg-gray-50 overflow-hidden">
        {/* Mobile Overlay */}
        {isSidebarOpen && (
          <div
            className="fixed inset-0 bg-black/50 z-40 lg:hidden"
            onClick={toggleSidebar}
          />
        )}

        {/* Sidebar */}
        <aside
          className={`
            fixed lg:static inset-y-0 left-0 z-50
            w-64 bg-gradient-to-b from-blue-950 to-blue-900 text-white
            transform transition-transform duration-300 ease-in-out
            ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
            flex flex-col shadow-2xl
          `}
        >
          {/* Sidebar Header */}
          <div className="p-6 border-b border-blue-800">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-3">
                <div className="bg-white/20 rounded-lg p-2">
                  <img src="/logo1.png" alt="Logo" className="w-8 h-8 object-contain" />
                </div>
                <div>
                  <h2 className="font-bold text-lg">
                    {allData.council ? allData.council[0]?.name : "Finance"}
                  </h2>
                  <p className="text-xs text-blue-200">
                    {allData.council ? "Council" : "Management System"}
                  </p>
                </div>
              </div>
              <button
                onClick={toggleSidebar}
                className="lg:hidden p-2 hover:bg-white/10 rounded-lg transition-colors"
              >
                <FaTimes className="text-white" />
              </button>
            </div>
          </div>

          {/* Navigation */}
          <nav className="flex-1 overflow-y-auto px-4 py-4">
            <p className="text-xs font-semibold text-blue-300 uppercase tracking-wider mb-3 px-3">
              Navigation
            </p>
            <ul className="space-y-1">
              {routes.map((route) => {
                const isActive = currentUrl === route.path;
                const Icon = route.icon;
                return (
                  <li key={route.path}>
                    <NavLink
                      to={route.path}
                      onClick={() => setIsSidebarOpen(false)}
                      className={`
                        flex items-center gap-3 px-4 py-3 rounded-lg
                        transition-all duration-200
                        ${
                          isActive
                            ? 'bg-white text-blue-950 shadow-lg font-semibold'
                            : 'text-blue-100 hover:bg-white/10 hover:text-white'
                        }
                      `}
                    >
                      <Icon className={isActive ? 'text-blue-950 text-lg' : 'text-blue-300 text-lg'} />
                      <span>{route.name}</span>
                    </NavLink>
                  </li>
                );
              })}
            </ul>
          </nav>

          {/* Sidebar Footer - User Info & Logout */}
          <div className="p-4 border-t border-blue-800">
            <div className="flex items-center gap-3 mb-3 px-2">
              <div className="bg-white/20 rounded-full p-2">
                <FaUser className="text-white text-sm" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-white truncate">
                  {auth.user?.name || 'User'}
                </p>
                <p className="text-xs text-blue-200 truncate">
                  {auth.user?.email || 'user@gramosi.com'}
                </p>
              </div>
            </div>
            <button
              onClick={signOut}
              className="w-full flex items-center gap-3 px-4 py-2.5 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors font-medium text-sm"
            >
              <FaSignOutAlt />
              <span>Logout</span>
            </button>
          </div>
        </aside>

        {/* Main Content */}
        <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
          {/* Header */}
          <header className="sticky top-0 z-30 bg-white/80 backdrop-blur-sm border-b border-gray-200 shadow-sm">
            <div className="px-4 lg:px-6 py-4">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <button
                    onClick={toggleSidebar}
                    className="lg:hidden p-2 hover:bg-gray-100 rounded-lg transition-colors"
                  >
                    <FaBars className="text-gray-700 text-xl" />
                  </button>
                  <div>
                    <h1 className="text-xl md:text-2xl font-bold text-gray-900">
                      {allData.council ? allData.council[0]?.name : 'Finance Management'}
                    </h1>
                    <p className="text-sm text-gray-500 hidden sm:block">
                      Financial management and accounting system
                    </p>
                  </div>
                </div>
                
                <div className="flex items-center gap-2">
                  {/* Notifications */}
                  <div className="relative">
                    <button className="p-2.5 hover:bg-gray-100 rounded-lg transition-colors relative">
                      <FaBell className="text-gray-700 text-xl" />
                      {transactions?.length > 0 && (
                        <span className="absolute -top-1 -right-1 flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-[10px] font-semibold text-white">
                          {transactions.length}
                        </span>
                      )}
                    </button>
                  </div>

                  {auth?.user?.userType == 2 && (
                    <NavLink
                      to={'/admin'}
                      className="p-2.5 hover:bg-gray-100 rounded-lg transition-colors relative"
                      title="Go to Admin Dashboard"
                    >
                      <GrUserAdmin className="text-gray-700 text-xl" />
                    </NavLink>
                  )}
                  <div className="hidden sm:flex items-center gap-3 ml-2 pl-3 border-l border-gray-200">
                    <div className="bg-blue-950 rounded-full p-2">
                      <FaUser className="text-white text-sm" />
                    </div>
                    <div className="hidden md:block">
                      <p className="text-sm font-medium text-gray-900">
                        {auth.user?.name || 'User'}
                      </p>
                      <p className="text-xs text-gray-500">Finance Officer</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </header>

          {/* Main Content Area */}
          <main className="flex-1 min-h-0 px-4 lg:px-6 py-4 lg:py-6 overflow-y-auto overflow-x-hidden">
            <div className="max-w-7xl mx-auto w-full">
              {allData.budget === undefined ? (
                <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-8">
                  <div className="max-w-4xl mx-auto">
                    <Skeleton count={6} height={100} className="mb-4" />
                  </div>
                </div>
              ) : (
                <Outlet context={{ allData, setAllData }} />
              )}
            </div>
          </main>

          {/* Footer */}
          <footer className="bg-white border-t border-gray-200 px-4 lg:px-6 py-4">
            <div className="max-w-7xl mx-auto">
              <p className="text-center text-sm text-gray-600">
                &copy; {new Date().getFullYear()} Gramosi. All rights reserved.
              </p>
            </div>
          </footer>
        </div>
      </div>
    );

}